var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankyoucircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2889,
    height: 1571,
    viewBox: "0, 0, 2889, 1571",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1001 -442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2690 1499 3434 1499 3434 1504 2690 1504Z",
    fill: "#3F3D56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2429 1633 3890 1633 3890 1638 2429 1638Z",
    fill: "#3F3D56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001 858 1745 858 1745 863 1001 863Z",
    fill: "#3F3D56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001 992 2462 992 2462 997 1001 997Z",
    fill: "#3F3D56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3125 1228C3125 1659.33 2775.56 2009 2344.5 2009 1913.44 2009 1564 1659.33 1564 1228 1564 796.665 1913.44 447 2344.5 447 2775.56 447 3125 796.665 3125 1228Z",
    fill: "#E6E6E6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2344.41 2012.96C1911.29 2012.96 1558.91 1660.81 1558.91 1227.96 1558.91 795.115 1911.29 442.965 2344.41 442.965 2777.54 442.965 3129.91 795.115 3129.91 1227.96 3129.91 1660.81 2777.54 2012.96 2344.41 2012.96ZM2344.41 451.406C1915.94 451.406 1567.36 799.769 1567.36 1227.96 1567.36 1656.16 1915.94 2004.52 2344.41 2004.52 2772.88 2004.52 3121.46 1656.16 3121.46 1227.96 3121.46 799.769 2772.88 451.406 2344.41 451.406Z",
    fill: "#3F3D56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971 575C1971 607.585 1944.36 634 1911.5 634 1878.64 634 1852 607.585 1852 575 1852 542.415 1878.64 516 1911.5 516 1944.36 516 1971 542.415 1971 575Z",
    fill: "#27A4F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644 987C1644 1007.99 1626.99 1025 1606 1025 1585.01 1025 1568 1007.99 1568 987 1568 966.013 1585.01 949 1606 949 1626.99 949 1644 966.013 1644 987Z",
    fill: "#FEB729",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3190 987.5C3190 1035.82 3150.6 1075 3102 1075 3053.4 1075 3014 1035.82 3014 987.5 3014 939.175 3053.4 900 3102 900 3150.6 900 3190 939.175 3190 987.5Z",
    fill: "#27A4F2",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyoucircle);
export default __webpack_public_path__ + "static/media/thankyoucircle.db168104f465194cc28f7157d611041b.svg";
export { ForwardRef as ReactComponent };